import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  status: 'initial',
  records: null,
};
const uploadAndAnalyzeAI = createSlice({
  name: 'uploadAndAnalyzeAI',
  initialState,
  reducers: {
    setStatusAnalyzeFile(state, action) {
      const { status, records } = action.payload;
      localStorage.setItem('statusAnalyzeFile', JSON.stringify({ status: status, records: records }));
      state.status = status;
      state.records = records;
    },
    clearStatusAnalyzeFile(state) {
      localStorage.removeItem('statusAnalyzeFile');
      state.status = 'none';
      state.records = null;
    },
  },
});
export const { setStatusAnalyzeFile, clearStatusAnalyzeFile } = uploadAndAnalyzeAI.actions;
export default uploadAndAnalyzeAI.reducer;
